export interface MarketingPlan {
    name: string;
    slug: string;
    price: number;
    dtes: number | "Ilimitados";
    users: number | "Ilimitados";
    branches: number | "Ilimitadas";
    dteScope: string;
    summary: string;
    analysis: string;
    cta: string;
    popular?: boolean;
    features: string[];
}

export const marketingPlans: MarketingPlan[] = [
    {
        name: "Emprendedor/MicroEmpresa",
        slug: "emprendedor",
        price: 11.99,
        dtes: 100,
        users: 1,
        branches: 1,
        dteScope: "Factura y CCF",
        summary: "Ideal para negocios pequeños que ya venden y necesitan emitir sus documentos base sin complicarse.",
        analysis: "Úsalo si tú y una persona de apoyo necesitan facturar, controlar clientes y productos, sin entrar todavía a documentos fiscales avanzados.",
        cta: "Elegir Plan",
        features: [
            "100 DTEs por mes",
            "1 usuario",
            "1 sucursal",
            "Factura Consumidor Final (01)",
            "Crédito Fiscal (03)",
            "PDF profesional y control básico",
        ],
    },
    {
        name: "Pyme",
        slug: "pyme",
        price: 29.99,
        dtes: 500,
        users: 3,
        branches: 3,
        dteScope: "Los 11 DTE",
        summary: "El plan más balanceado para empresas que ya operan con ventas, contabilidad y más de un usuario.",
        analysis: "Es el plan recomendado para la mayoría: permite equipo pequeño, más volumen y acceso real al flujo completo de DTE, gastos y reportes.",
        cta: "Comenzar Ahora",
        popular: true,
        features: [
            "500 DTEs por mes",
            "3 usuarios",
            "3 sucursales",
            "Los 11 tipos de DTE",
            "Gastos con escáner IA",
            "Reportes y soporte prioritario",
        ],
    },
    {
        name: "Empresarial",
        slug: "empresarial",
        price: 69.99,
        dtes: "Ilimitados",
        users: "Ilimitados",
        branches: "Ilimitadas",
        dteScope: "Los 11 DTE + operación ampliada",
        summary: "Pensado para compañías con varios usuarios, sucursales, procesos contables exigentes y mayor volumen operativo.",
        analysis: "Va mejor cuando ya necesitas delegar trabajo, crecer sin topar límites y preparar integraciones o atención más cercana.",
        cta: "Solicitar Plan",
        features: [
            "DTEs ilimitados",
            "Usuarios ilimitados",
            "Sucursales ilimitadas",
            "Los 11 tipos de DTE",
            "API e integraciones",
            "Soporte dedicado",
        ],
    },
];

export function getMarketingPlanDisplayName(slug: string) {
    return marketingPlans.find((plan) => plan.slug === slug)?.name ?? slug;
}
